import { render, staticRenderFns } from "./expander.vue?vue&type=template&id=38a90a9b&scoped=true&"
import script from "./expander.vue?vue&type=script&lang=js&"
export * from "./expander.vue?vue&type=script&lang=js&"
import style0 from "./expander.vue?vue&type=style&index=0&id=38a90a9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a90a9b",
  null
  
)

export default component.exports